<template>
  <div class="material-wrap">
    <div class="header-wrap">
      <el-select
        v-for="item in materialFieldsObj"
        :key="item.key"
        class="select-item"
        v-model="filterData[item.key]"
        :placeholder="`选择${item.name}`"
        multiple
        collapse-tags
        filterable
      >
        <el-option v-for="child in getSelectOptions(item)" :key="child.id" :label="child.name" :value="child.id"></el-option>
      </el-select>
      <el-cascader
        class="select-item"
        style="width: 350px"
        placeholder="选择标签"
        v-model="filterData.tagIds"
        :options="tagList"
        collapse-tags
        clearable
        :props="{ multiple: true, value: 'id', label: 'tagName', emitPath: false }"
        filterable
      ></el-cascader>
      <el-select
        class="select-item multiple-select"
        v-model="filterData.advertiserIds"
        placeholder="选择广告投放账户"
        multiple
        collapse-tags
        filterable
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.company + ' (' + item.advertiserName + ')'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <el-input placeholder="请输入名称/素材ID" suffix-icon="el-icon-search" class="select-item" v-model="filterData.search"></el-input>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px"
        value-format="yyyyMMdd"
        :clearable="false"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button class="submit-btn" style="margin-left: auto" @click="handlerReset">重置</el-button>
      <el-button class="submit-btn" type="primary" @click="handlerSearch">查询</el-button>
      <!-- 选择字段弹框 -->
      <select-field
        class="submit-btn"
        :options="fieldOptions"
        :staticOptions="staticOptions"
        @changeColumn="generateCols"
        :type="5"
      ></select-field>
    </div>
    <div class="table-wrap">
      <div class="content-table-wrap">
        <el-table :data="tableData" v-loading="loading" :max-height="tableMaxHeight">
          <template #header>
            <el-tooltip class="item" effect="dark" :content="item.tip" placement="top">
              <i v-if="item.tip" class="el-icon-question"> </i>
            </el-tooltip>
            <span style="margin-left: 10px" v-if="item.copy">
              <i @click.stop="onClick(item.key, item.name, item.percent, item.unit)" class="el-icon-document-copy"> </i
            ></span>
          </template>
          <el-table-column v-for="item of staticOptions" :key="item.value" :prop="item.value" :label="item.label" width="200" :fixed="true">
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              width="200"
              :key="item.value"
            >
              <template slot-scope="scope">
                <span>{{ scope.row[item.value] || "--" }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              :width="item.width"
              :key="item.value"
            >
              <template slot-scope="scope">
                <span v-if="scope.row[item.value] == null">--</span>
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdvertiserInfo, materialReport } from "@/api/report.js";
import { getTagPropertySelectList, getTagRuleList } from "@/api/property";
import SelectField from "@/components/selectField.vue";
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import moment from "moment";
import { accMul } from "@/utils/math";
import { materialFieldsObj } from "@/config/fieldData";
export default {
  name: "materialReport",
  components: {
    SelectField,
  },
  data() {
    return {
      demanderList: [],
      designerList: [],
      tagList: [],
      materialTypeList: [],
      playList: [],
      resolutionList: [],
      languageList: [],
      materialFieldsObj,
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      advertiserIdList: [],
      filterData: {
        demanderIds: [],
        designerIds: [],
        tagIds: [],
        advertiserIds: [],
        materialTypes: [],
        playTypes: [],
        resolutions: [],
        langs: [],
        time: [moment().subtract(7, "days").format("YYYYMMDD"), moment().subtract(1, "days").format("YYYYMMDD")],
        search: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      loading: false,
      tableCols: [],
      tableData: [],
      fieldOptions: [
        {
          title: "属性数据",
          list: [
            { label: "设计", value: "designerName" },
            { label: "后期", value: "demanderName" },
            { label: "标签", value: "tag" },
          ],
        },
        {
          title: "推广数据",
          list: [
            { label: "消耗", value: "cost" },
            { label: "展示数", value: "showCnt" },
            { label: "点击数", value: "clickCnt" },
            { label: "平均千次展现费用(元)", value: "thousandDisplayPrice" },
            { label: "平均点击单价(元)", value: "cpc" },
            { label: "点击率(%)", value: "ctr" },
            { label: "激活数", value: "active" },
            { label: "激活成本", value: "activeCost" },
            { label: "激活率(%)", value: "activeRate" },
            { label: "转化数", value: "convertCnt" },
            { label: "转化成本", value: "convertCntCost" },
            { label: "转化率(%)", value: "convertCntRate" },
            { label: "展示转化率(%)", value: "convertShowRate" },
            { label: "平均单次播放时长", value: "perPlayTime" },
            { label: "播放数", value: "totalPlay" },
            { label: "有效播放数", value: "validPlay" },
            { label: "有效播放率(%)", value: "validPlayRate" },
            { label: "完播率(%)", value: "playOverRate" },
            { label: "2秒播放率", value: "playDuration2sRate" },
            { label: "3秒播放率", value: "playDuration3sRate" },
            { label: "10秒播放率", value: "playDuration10sRate" },
            { label: "播放完成数", value: "playOver" },
            { label: "25%进度播放率", value: "play25FeedBreakRate" },
            { label: "50%进度播放率", value: "play50FeedBreakRate" },
            { label: "75%进度播放率", value: "play75FeedBreakRate" },
            { label: "99%进度播放率", value: "play99FeedBreakRate" },
          ],
        },
      ],
      staticOptions: [
        { label: "素材ID", value: "materialId" },
        { label: "文件名", value: "name" },
      ],
      tableMaxHeight: window.innerHeight - 340,
      totalColumn: {},
      totalReportInfo: [],
    };
  },
  watch: {
    totalReportInfo: {
      handler(value) {
        let totalData = {};
        if (value?.length > 0) {
          totalData = value[0];
        }
        totalData.materialId = "合计";
        totalData.name = `选中${this.pageData.total || 0}个文件`;
        totalData.designerName = "--";
        totalData.demanderName = "--";
        totalData.tag = "--";
        this.totalColumn = totalData;
      },
      immediate: true,
    },
  },
  computed: {},
  mounted() {
    this.initSelectOptions();
    this.getList();
  },
  methods: {
    getSelectOptions(val) {
      return this[val.optionsName];
    },
    initSelectOptions() {
      this.materialFieldsObj.map((item) => {
        getTagPropertySelectList({ type: item.type }).then((res) => {
          this[item.optionsName] = res.data;
        });
      });
      //标签
      getTagRuleList().then((res) => {
        this.tagList = res.data;
      });
      getAdvertiserInfo().then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
    },
    handlerReset() {
      this.filterData = {
        demanderIds: [],
        designerIds: [],
        tagIds: [],
        advertiserId: [],
        materialTypes: [],
        playTypes: [],
        resolutions: [],
        langs: [],
        time: [moment().subtract(7, "days").format("YYYYMMDD"), moment().subtract(1, "days").format("YYYYMMDD")],
        search: "",
      };
      this.pageData.page = 1;
      this.getList();
    },
    handlerSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      let parmas = this.formatData();
      const rateFields = [
        "ctr",
        "activeRate",
        "convertCntRate",
        "convertShowRate",
        "validPlayRate",
        "playOverRate",
        "playDuration2sRate",
        "playDuration3sRate",
        "playDuration10sRate",
        "play25FeedBreakRate",
        "play50FeedBreakRate",
        "play75FeedBreakRate",
        "play99FeedBreakRate",
      ];
      const moneyFields = ["cost", "thousandDisplayPrice", "cpc", "activeCost", "convertCntCost", "perPlayTime"];
      materialReport(parmas)
        .then((res) => {
          if (res.code === "0000") {
            this.tableData = res.data.pageInfo?.list?.map((item) => {
              rateFields.map((field) => {
                item[field] = accMul(item[field] || 0, 100) + "%";
              });
              moneyFields.map((field) => {
                item[field] = Number(item[field] || 0).toFixed(2);
              });
              return item;
            });
            if (this.pageData.page === 1) {
              const data = JSON.parse(JSON.stringify(res.data.totalReportInfo ? [res.data.totalReportInfo] : []));
              this.totalReportInfo = data?.map((item) => {
                rateFields.map((field) => {
                  item[field] = accMul(item[field] || 0, 100) + "%";
                });
                moneyFields.map((field) => {
                  item[field] = Number(item[field] || 0).toFixed(2);
                });
                return item;
              });
            }
            this.pageData.total = res.data.pageInfo?.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startDate: this.filterData.time[0],
        endDate: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        parmas[key] = checkData;
      }
      return parmas;
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "designerName",
          "demanderName",
          "tag",
          "cost",
          "showCnt",
          "clickCnt",
          "thousandDisplayPrice",
          "cpc",
          "ctr",
          "active",
          "activeCost",
          "activeRate",
          "convertCnt",
          "convertCntCost",
          "convertCntRate",
        ];
      }
      let allFieldsMap = this.fieldOptions[0].list.concat(this.fieldOptions[1].list); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.material-wrap {
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  .header-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 24px 0px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    .select-item {
      width: 240px;
      margin-right: 24px;
      margin-bottom: 16px;
      /deep/ .el-input__inner {
        height: 32px !important;
      }
      /deep/ .el-cascader__search-input {
        min-width: 15px;
      }
      /deep/ .el-tag {
        max-width: 210px;
      }
    }
    .data-range {
      position: relative;
      margin-bottom: 16px;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .submit-btn {
      margin-bottom: 16px;
      margin-left: 20px;
    }
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    margin-top: 16px;
    .content-table-wrap {
      width: calc(100vw - 265px);
    }
  }
}
</style>
